import React from "react"
import Icon from "components/Icon";

function SupportCta() {
  return (
    <div className="flex justify-center items-center" >
      <Icon name="info circle" className="text-primary" size='large' />
      <span>Hai bisogno di aiuto?</span>
      <a href="mailto:hello@timesafe.io" className="font-bold ml-2 no-underline hover:text-gray-900 hover:shadow-none" >Richiedi assistenza</a>
    </div>
  )
}

export default SupportCta